const labourService = {
  title: "Labour",
  icon: "👷",
  shortDescription:
    "General labour, helpers, loading-unloading, site movement, and execution support.",
  longDescription:
    "Book labour support for on-site work, shifting, loading-unloading, material movement, and construction assistance. Choose carefully between Helper and General Labour so the assigned worker scope matches the actual job.",
  consultationNote:
    "Heavy-material, high-floor, night work, and large crew needs may require special handling.",
  responsePromise:
    "Assignment depends on task nature, area, shift length, and active worker availability.",
  warrantyPolicy:
    "Labour support is execution-based; revisit or dispute support depends on job context.",
  subServices: [
    {
      id: "labour-helper-halfday",
      title: "Helper - Half Day",
      icon: "🤝",
      group: "Helper",
      description:
        "Booked for support-only assistance for 4-5 hours, not for full physical labour execution.",
      basePrice: 499,
      priceType: "fixed",
      duration: "4-5 hrs",
      warranty: "Execution support",
      unit: "shift",
      workIncludes: [
        "Handing tools and basic material support to the lead worker",
        "Light site cleanup and support movement inside the work area",
        "Bringing small items, water, consumables, and helper-level assistance",
        "Basic assistance under supervision during home or site work",
      ],
      notFor: [
        "Heavy lifting or continuous construction-grade manual labour",
        "Cement mixing, concrete loading, brick or block carrying for long cycles",
        "Independent site execution without a lead skilled worker",
        "Mason, welder, electrician, plumber, or fabrication work",
      ],
      scopeNote:
        "Choose Helper only for support work. If the task involves sustained physical construction work, book General Labour instead.",
    },
    {
      id: "labour-helper-fullday",
      title: "Helper - Full Day",
      icon: "🤝",
      group: "Helper",
      description:
        "Booked for full-day support assistance around a worker, household job, or site team, not as a substitute for general labour.",
      basePrice: 799,
      priceType: "fixed",
      duration: "8-9 hrs",
      warranty: "Execution support",
      unit: "shift",
      workIncludes: [
        "Support to skilled workers across the day",
        "Light item movement and staging inside the home or site",
        "Cleanup help, supply fetching, and helper-level site coordination",
        "Basic assistance where the main physical job is handled by another worker",
      ],
      notFor: [
        "Heavy material handling across the full day",
        "Digging, debris removal, continuous loading-unloading, or slab prep work",
        "Independent execution of construction labour work",
        "Replacement for a mason, carpenter, welder, or technician",
      ],
      scopeNote:
        "Book General Labour if you need real manual site output. Helper is for assistance, not primary labour execution.",
    },
    {
      id: "labour-general-halfday",
      title: "General Labour - Half Day",
      icon: "🏗️",
      group: "General Labour",
      description:
        "Booked for 4-5 hours of active manual labour, physical site work, and heavier execution tasks.",
      basePrice: 649,
      priceType: "fixed",
      duration: "4-5 hrs",
      warranty: "Execution support",
      unit: "shift",
      workIncludes: [
        "Construction-site physical work and manual execution support",
        "Carrying heavier materials, debris, tools, or site items as part of the job",
        "Loading-unloading, shifting, filling, digging, and movement-heavy tasks",
        "Hands-on labour support for masonry, concrete, site prep, and general execution",
      ],
      notFor: [
        "Specialized trade work that requires a mason, plumber, electrician, welder, or fabricator",
        "Machine-operated work or technical installation work",
        "Only light helper assistance around a lead worker",
      ],
      scopeNote:
        "Choose General Labour when you need actual manual work output, not just assistance around someone else's work.",
    },
    {
      id: "labour-general-fullday",
      title: "General Labour - Full Day",
      icon: "🏗️",
      group: "General Labour",
      description:
        "Booked for a full day of physical labour, material movement, and on-site manual execution.",
      basePrice: 999,
      priceType: "fixed",
      duration: "8-9 hrs",
      warranty: "Execution support",
      unit: "shift",
      workIncludes: [
        "Full-day site labour for physical execution tasks",
        "Heavy shifting, repetitive carry work, and longer-cycle material movement",
        "Construction support such as debris handling, filling, movement, and prep work",
        "Manual labour where real body-work output is expected across the shift",
      ],
      notFor: [
        "Skilled trade execution like masonry finishing, wiring, plumbing, or welding",
        "Support-only helper tasks where physical output is light",
        "Technical supervision or site engineer responsibilities",
      ],
      scopeNote:
        "This is the correct selection for sustained manual labour. Do not book a Helper if this is the actual work requirement.",
    },
    {
      id: "labour-loading-unloading",
      title: "Loading / Unloading Support",
      icon: "📦",
      group: "Movement",
      description:
        "Support for material loading, unloading, or movement on site or at delivery point.",
      basePrice: 699,
      priceType: "starts_at",
      duration: "2-4 hrs",
      warranty: "Execution support",
      unit: "job",
      workIncludes: [
        "Loading or unloading construction, household, or shop items",
        "Point-to-point physical handling at the pickup or drop location",
        "Basic stacking and movement within practical site limits",
      ],
      notFor: [
        "Skilled installation, assembly, wiring, plumbing, or masonry work after unloading",
        "Long-duration full-day site labour outside the movement job scope",
      ],
    },
    {
      id: "labour-shifting-support",
      title: "Material Shifting Support",
      icon: "🚚",
      group: "Movement",
      description:
        "Move construction items or household heavy items within site or building limits.",
      basePrice: 699,
      priceType: "starts_at",
      duration: "2-4 hrs",
      warranty: "Execution support",
      unit: "job",
      workIncludes: [
        "Internal shifting of materials or heavy items within a site or building",
        "Physical movement between rooms, floors, or work zones where feasible",
        "Short-cycle support for reorganizing site or household items",
      ],
      notFor: [
        "Transport vehicle arrangement or off-site logistics",
        "Skilled repair, fitting, or installation after shifting is complete",
      ],
    },
  ],
};

export default labourService;
